/**
 * Normalizes vehicle module grid API responses (Kendo-style Total + portal TotalCount).
 * @param {object|null|undefined} res
 * @returns {{ data: any[], totalCount: number }}
 */
export function normalizeVehicleGridResponse(res) {
  if (res == null || typeof res !== 'object') {
    return { data: [], totalCount: 0 };
  }
  const data = Array.isArray(res.Data)
    ? res.Data
    : Array.isArray(res.data)
      ? res.data
      : [];
  const raw =
    res.TotalCount ??
    res.totalCount ??
    res.Total ??
    res.total ??
    (Array.isArray(data) ? data.length : 0);
  const totalCount = Number(raw);
  return { data, totalCount: Number.isFinite(totalCount) ? totalCount : 0 };
}

/** VehiclesInDropDown uses Number; UI expects PlateNumber for labels. */
export function mapVehicleDropdownList(list) {
  if (!Array.isArray(list)) return [];
  return list.map((v) => {
    if (!v || typeof v !== 'object') return v;
    const id = v.Id ?? v.id;
    const number = v.Number ?? v.number ?? '';
    return {
      ...v,
      Id: id,
      PlateNumber: v.PlateNumber ?? number,
      Number: number,
    };
  });
}

/**
 * Maps a vehicle API row to the add/edit form shape (Number = plate / fleet number).
 * @param {object|null|undefined} row
 * @returns {object|null}
 */
export function mapVehicleDetailToForm(row) {
  if (!row || typeof row !== 'object') return null;
  const id = row.Id ?? row.ID ?? 0;
  const plate = row.Number ?? row.PlateNumber ?? '';
  return {
    Id: Number(id) || 0,
    Number: typeof plate === 'string' ? plate : String(plate ?? ''),
    Model: row.Model ?? '',
    Make: row.Make ?? '',
    Year: row.Year != null && row.Year !== '' ? String(row.Year) : '',
    Color: row.Color ?? '',
    RegistrationNumber: row.RegistrationNumber ?? '',
    ChassisNumber: row.ChassisNumber ?? '',
    EngineNumber: row.EngineNumber ?? '',
    IsActive: row.IsActive !== false && row.IsActive !== 0,
  };
}

export function isApiSaveSuccess(res) {
  if (res === true || res === 'true' || res === 'Success') return true;
  if (res && typeof res === 'object' && (res.Id != null || res.ID != null)) return true;
  return false;
}

export function isApiDeleteSuccess(res) {
  if (res === 'Success' || res === true || res === 'true') return true;
  return false;
}
